import { dayjs } from '@revolugo/common/utils'
import { computed, watch } from 'vue'

import Revolugo from '../primevue/themes/revolugo/index.ts'

import type { PrimeVueConfiguration } from 'primevue/config'
import type { App } from 'vue'

export { default as PrimeVue } from 'primevue/config'

export const PRIME_CONFIG: PrimeVueConfiguration = {
  pt: Revolugo,
  theme: 'none',
  unstyled: true,
  zIndex: {
    overlay: 3000,
  },
}

export const usePrimeVueLocale = (app: App) => {
  const localeData = dayjs.localeData()
  const locale = computed(() => app.config.globalProperties.$i18n.locale)

  watch(
    locale,
    () => {
      const monthNames = localeData
        .months()
        .map(
          value =>
            `${value.substring(0, 1).toUpperCase()}${value.substring(1)}`,
        )

      app.config.globalProperties.$primevue.config.locale = {
        dayNames: localeData.weekdays(),
        dayNamesMin: localeData.weekdaysMin(),
        dayNamesShort: localeData.weekdaysShort(),
        fileSizeTypes: ['Bytes', 'KB', 'MB', 'GB', 'TB'],
        firstDayOfWeek: localeData.firstDayOfWeek(),
        monthNames,
        monthNamesShort: localeData.monthsShort(),
      }
    },
    {
      immediate: true,
    },
  )
}
